<template>
  <div v-if="isSoldOut || item.NO_SPB || item.NO_MSK" class="only-in size4 d-inline-block">
    <div v-if="isSoldOut" class="--sold-out">Sold out</div>
    <div v-else-if="item.NO_SPB">Только в Москве</div>
    <div v-else-if="item.NO_MSK">Только в Петербурге</div>
  </div>
</template>

<script>
import city from "@/mixins/city";
import config from "@/config";

export default {
  name: 'only-in',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  mixins: [city],
  computed: {
    isSoldOut() {
      return (this.isSpb && this.item.IS_SOLD_OUT) || (this.isMsk && this.item.IS_SOLD_OUT_MSK) || (this.item.NO_SPB && this.item.NO_MSK);
    },
    isSpb() {
      return this.currentCity === config.CITIES[0].name;
    },
    isMsk() {
      return this.currentCity === config.CITIES[1].name;
    },
  }
}
</script>

<style lang="scss">
.only-in {
  div {
    font-family: $body-font-family;
    text-transform: uppercase;
    background-color: #eaeaea;
    padding: 4px 8px;

    &.--sold-out {
      background-color: $red2;
      color: $gray2;
    }
  }
}
</style>